<template>
    <div class="col-12">
        <div class="row" style="margin-top: 2px">
            <div class="col-lg-1 col-form-label" style="text-align: left">
                {{ $t('inventory_stock_in_qty') }}
            </div>
            <div class="col-lg-5">
                <input type="number" pattern="\d*" class="form-control" @change="calCTN('qty')" v-model="getQty"
                       id="inputQtyID"
                       :disabled="this.ctnQty === null || this.flag === false">
            </div>
            <div class="col-lg-2 col-form-label" style="text-align: left">
                {{ $t('inventory_stock_in_ctn') }}&nbsp;({{ ctnQty }})
            </div>
            <div class="col-lg-4">
                <input class="form-control" @change="calCTN('ctn')" v-model="getCtn"
                       :disabled="this.ctnQty === null || this.flag === false">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "QtyProcessor",
    props:{
        ctnQty: '',
        flag: '',
    },
    data(){
        return{
            getQty: '',
            getCtn: '',
        }
    },
    methods: {
        getFocus(){
            document.getElementById("inputQtyID").focus();
        },
        clearMode(){
            this.getCtn = null
            this.getQty = null
        },
        updateModeOnQty(data){
            this.getCtn = data['ctn']
            this.getQty = data['qty']
        },
        calCTN(getFlag){
            if(getFlag === 'qty'){
                // qty changed
                if(Number.isInteger(this.getQty) && this.getQty > 0){
                    this.getCtn = Math.round((this.getQty/this.ctnQty) * 10000) / 10000
                }else{
                    this.clearMode()
                    this.$swal.fire({
                        title: this.$t('error_input_number_pos'),
                        icon: "warning"
                    })
                }
            }else{
                if(this.getCtn > 0){
                    this.getQty = Math.floor(this.ctnQty*this.getCtn)
                }else{
                    this.clearMode()
                    this.$swal.fire({
                        title: this.$t('error_input_number_pos'),
                        icon: "warning"
                    })
                }
            }
            this.$emit('returnQty', {
                "qty": this.getQty,
                "ctn": this.getCtn
            })
        },
    }
}
</script>

<style scoped>

</style>
